import locale from '../locale';

export default function(axios) {
  axios.interceptors.request.use(async (config) => {
    config.headers['Language'] = locale;
    return config;
  }, (error) => {
    return Promise.reject(error);
  });
};


// WEBPACK FOOTER //
// ./src/lang/interceptors/LanguageHeader.js